import { render, staticRenderFns } from "./CarInfoHead.vue?vue&type=template&id=16d18b6a&"
import script from "./CarInfoHead.vue?vue&type=script&lang=js&"
export * from "./CarInfoHead.vue?vue&type=script&lang=js&"
import style0 from "./CarInfoHead.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports